/* eslint-disable no-undef */
import React, {Component} from "react";
import {Checkbox, FormControl, FormControlLabel, FormGroup} from '@material-ui/core';
import 'react-tabs/style/react-tabs.css';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {makeStyles} from "@material-ui/core/styles";
import Api from "../../../../../Services/Api";

const classes = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    formControl: {
        margin: theme.spacing(3),
    },
}));

class TabMenuAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ? props.data : {
                roleId: ""
            },
            dataRequest: [],
            menuAccessData: [],
        }
    }

    componentDidMount() {
        this.getMenuAccess()
    }

    getMenuAccess() {
        let payload = {
            roleId: this.state.data.roleId,
        }
        if (this.props.data.accessType === 'Allowed') {
            Api.create('MASTERDATA_EKSAD').postGetRoleMenuAllowed(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            item.formAccess.map((itemAccess) => {
                                if(itemAccess.accessMenu){
                                    arrayDataRequest.push({
                                        roleId: itemAccess.roleId,
                                        companyId: this.state.data.companyId,
                                        formId: itemAccess.formId,
                                        status: "Active",
                                    })
                                }
                            })
                        })
                        this.setState({
                            menuAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        } else {
            Api.create('MASTERDATA_EKSAD').postGetRoleMenuBanned(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            item.formAccess.map((itemAccess) => {
                                if(itemAccess.accessMenu){
                                    arrayDataRequest.push({
                                        roleId: itemAccess.roleId,
                                        companyId: this.state.data.companyId,
                                        formId: itemAccess.formId,
                                        status: "Active",
                                    })
                                }
                            })
                        })
                        this.setState({
                            menuAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        }
    }

    onCheckAccess(itemData, itemAccess) {
        let dataArray = [...this.state.menuAccessData];
        let objIndex = dataArray.findIndex((obj => obj.menuId === itemData.menuId));

        let dataAccess = dataArray[objIndex].formAccess;
        let objIndexAccess = dataAccess.findIndex((obj => obj.description === itemAccess.description))
        if (itemAccess.accessMenu === false) {
            dataAccess[objIndexAccess].accessMenu = true
            this.setState({
                menuAccessData: dataArray,
            })
            this.state.dataRequest.push({
                roleId: dataAccess[objIndexAccess].roleId,
                companyId: this.state.data.companyId,
                formId: dataAccess[objIndexAccess].formId,
                status: "Active",
            })
        } else {
            dataAccess[objIndexAccess].accessMenu = false
            this.setState({
                menuAccessData: dataArray,
            })
            let index = this.state.dataRequest.findIndex((obj => obj.formId === dataAccess[objIndexAccess].formId));
            this.state.dataRequest.splice(index, 1);
        }
        this.props.requestData(this.state.dataRequest);
    }

    render() {
        return (
            <div style={{width: '95%', height: '40%'}}>
                {this.state.menuAccessData.map((itemData, i) => {
                    return (
                        <div key={i}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>{itemData.description}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="grid grid-2x" style={{width: '50%'}}>
                                        {itemData.formAccess.map((itemAccess, i) => {
                                            return (
                                                <div key={i}>
                                                    <FormControl required component="fieldset"
                                                                 className={classes.formControl}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <div style={{flexWrap: 'wrap'}}>
                                                                        <Checkbox
                                                                            style={{color: 'grey'}}
                                                                            checked={itemAccess.accessMenu}
                                                                            onChange={() => this.onCheckAccess(itemData, itemAccess)}
                                                                            disabled={this.props.type === "view"}
                                                                        />
                                                                    </div>
                                                                }
                                                                label={<span
                                                                    style={{fontSize: '15px'}}>{itemAccess.description}</span>}
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default TabMenuAccess;